import { Col, Row } from 'antd'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { InfoCircleOutlined } from '@ant-design/icons'
import Icons from '../../../../../../Main/Components/Icons'
import { useParams } from 'react-router-dom'

const InformationBanner = styled.div`
  margin-top: 2.4rem;
  margin-bottom: 2.4rem;
  border-radius: 0.8rem;
  background: #e6f7ff;
  border: solid 0.1rem #91d5ff;
  border-left: solid 0.4rem #91d5ff;
  padding: 1.6rem;

  & > div {
    & > div:nth-child(1) {
      text-align: center;
    }
    & > div:nth-child(2) {
      & > label {
        color: #000000d9;
        font-size: 1.4rem;
        font-weight: 500;
        & > span {
          font-weight: 700;
        }
      }
    }
    & > div:nth-child(3) {
      text-align: right;
      & > div {
        & > div {
          & > div:nth-child(1) {
            display: inline-block;
            margin-right: 0.8rem;
          }
          & > div:nth-child(2) {
            display: inline-block;
            & > label {
              cursor: pointer;
              color: #1677ff;
              font-size: 1.4rem;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
`

type RouteTask = {
  id: string
  ordering: number
  routeNumber: string
}

type JobAssignedToRouteBannerProps = {
  route: RouteTask
  store: any
  selectedTask: any
  onCloseModal: () => void
}

const JobAssignedToRouteBanner = (props: JobAssignedToRouteBannerProps) => {
  const { route, store, selectedTask, onCloseModal } = props
  const { t } = useTranslation()
  const { routeId } = useParams()

  const onGoToAssignedRoute = (route: RouteTask) => {
    if (routeId) {
      onCloseModal()
    } else {
      window.location.replace(`/routes/stores/${store.id}/routes/${route.id}`)
    }
  }

  return (
    <InformationBanner>
      <Row>
        <Col span={1}>
          <InfoCircleOutlined style={{ color: '#1677FF' }} />
        </Col>
        <Col span={18}>
          <label>
            {selectedTask.resources.length === 0
              ? `${t<string>('jobs.tasks.task.task-in-route')} `
              : `${t<string>('jobs.tasks.task.reassing-task-in-route')} `}
            <span>
              {t<string>('route').toLocaleLowerCase()} {route.routeNumber}
            </span>
          </label>
        </Col>
        <Col span={5}>
          <Row>
            <Col span={24} onClick={() => onGoToAssignedRoute(route)}>
              <div>
                <label>
                  <span>
                    <Icons iconName='Link' style={{ color: '#1677FF', cursor: 'pointer' }} />
                  </span>
                </label>
              </div>
              <div>
                <label>{t<string>('jobs.tasks.task.go-to-route')}</label>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </InformationBanner>
  )
}

export { JobAssignedToRouteBanner }
